<template>
  <div class="mb-5 ">
    <div class="row col-lg-12" style="text-align: center">
      <div class="col-lg-12">
        <strong class="titulo-seccion" style="text-align: left; margin-right: 10px">Biblioteca Digital</strong>
      </div>
    </div>
    <hr height="3px" style="color:#000000;" />
    <div class="px-3 px-md-4  px-lg-5 ">
      <CarruselDigital />
      <CardBlogBiblioteca :posts="arrayPosts" />
      <CardManuales :manuals="arrayManuals" />
      <CardVideo :videos="arrayVideos" />
    </div>
  </div>
</template>
<script>
import CarruselDigital from "@/Aplicaciones/Masters/Areas/Master/components/biblioteca/CarruselDigital.vue"
import CardBlogBiblioteca from "@/Aplicaciones/Masters/Areas/Master/components/biblioteca/CardBlogBiblioteca.vue";
import CardManuales from "@/Aplicaciones/Masters/Areas/Master/components/biblioteca/CardManuales.vue";
import CardVideo from "@/Aplicaciones/Masters/Areas/Master/components/biblioteca/CardVideo.vue";
import axios from "axios";
const ruteBibliotecaDigital = "/api/BibliotecaDigital/BibliotecaDigital";


export default {
  components: {
    CarruselDigital,
    CardBlogBiblioteca,
    CardManuales,
    CardVideo
  },
  name: "BibliotecaDigital",
  data() {
    return {
      tituloDocumento: '',
      ligaArchivo: '',
      arrayPosts: [],
      arrayManuals: [],
      arrayVideos: []

    };
  },
  async mounted() {
    const { data } = await axios(ruteBibliotecaDigital + '/ObtenerBibliotecaDigital')
    const { manuales, videos, post } = data.data
    this.arrayPosts = post
    this.arrayManuals = manuales
    this.arrayVideos = videos
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../assets/estilos/estilosgenerales.scss";
</style>
